<template>
    <popper
        :trigger="trigger"
        :delay-on-mouse-over="$attrs['open-delay'] ? $attrs['open-delay'] : 0"
        :options="{
            placement: placement,
            modifiers: { offset: { offset: '0, 5px' }}
        }"
        transition="fade"
        enter-active-class="fade-enter fade-enter-active"
        leave-active-class="fade-leave fade-leave-active"
        append-to-body>
        <div :class="align ? 'text-' + align : 'text-left'" class="popper popper-tooltip">
            <div v-if="$attrs.content">
                {{ $attrs.content }}
            </div>
            <slot v-else name="content" />
        </div>
        <slot slot="reference" />
    </popper>
</template>

<script>
import Popper from 'vue-popperjs';

export default {
    name: 'app-tooltip',
    components: {
        'popper': Popper
    },
    props: {
        trigger: {
            type: String,
            default: 'hover'
        },
        placement: {
            type: String,
            default: 'top'
        },
        align: {
            type: String,
            default: 'left'
        }
    }
}
</script>

<style lang="stylus">
    .fade-enter-active,
    .fade-leave-active
        transition: opacity .3s;

    .fade-enter-to .popper.popper-tooltip
        transition: .3s
        opacity: 1

    .fade-leave-to .popper.popper-tooltip
        transition: .3s
        opacity: 0
    
    .fade-enter .popper.popper-tooltip
        opacity: 0

    .popper.popper-tooltip
        &.text-left
            text-align: left
        &.text-right
            text-align: right
        &.text-center
            text-align: center
    
    .popper.popper-tooltip
        width: auto;
        background: #303133;
        color: #fff;
        text-align: center;
        padding: 10px;
        display: inline-block;
        border-radius: 6px;
        position: absolute;
        font-size: 12px;
        font-weight: normal;
        border: 0px #303133 solid;
        z-index: 200000;

    .popper.popper-tooltip .popper__arrow
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;

    .popper.popper-tooltip[x-placement^="top"]
        margin-bottom: 5px;

    .popper.popper-tooltip[x-placement^="top"] .popper__arrow
        border-width: 5px 5px 0 5px;
        border-color: #303133 transparent transparent transparent;
        bottom: -5px;
        left: calc(50% - 10px) !important;
        margin-top: 0;
        margin-bottom: 0;

    .popper.popper-tooltip[x-placement^="top-start"]
        margin-bottom: 5px;

    .popper.popper-tooltip[x-placement^="top-start"] .popper__arrow
        border-width: 5px 5px 0 5px;
        border-color: #303133 transparent transparent transparent;
        bottom: -5px;
        left: 2px !important;
        margin-top: 0;
        margin-bottom: 0;

    .popper.popper-tooltip[x-placement^="top-end"]
        margin-bottom: 5px;

    .popper.popper-tooltip[x-placement^="top-end"] .popper__arrow
        border-width: 5px 5px 0 5px;
        border-color: #303133 transparent transparent transparent
        bottom: -5px;
        left: calc(100% - 27px) !important
        margin-top: 0;
        margin-bottom: 0;

    .popper.popper-tooltip[x-placement^="bottom"]
        margin-top: 5px;

    .popper.popper-tooltip[x-placement^="bottom"] .popper__arrow
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #303133 transparent
        top: -5px;
        left: calc(50% - 10px) !important
        margin-top: 0;
        margin-bottom: 0;

    .popper.popper-tooltip[x-placement^="bottom-start"]
        margin-top: 5px;

    .popper.popper-tooltip[x-placement^="bottom-start"] .popper__arrow
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #303133 transparent
        top: -5px;
        left: 2px !important
        margin-top: 0;
        margin-bottom: 0;

    .popper.popper-tooltip[x-placement^="bottom-end"]
        margin-top: 5px;

    .popper.popper-tooltip[x-placement^="bottom-end"] .popper__arrow
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #303133 transparent
        top: -5px;
        left: calc(100% - 27px) !important
        margin-top: 0;
        margin-bottom: 0;

    .popper.popper-tooltip[x-placement^="right"]
        margin-left: 5px;

    .popper.popper-tooltip[x-placement^="right"] .popper__arrow
        border-width: 5px 5px 5px 0;
        border-color: transparent #303133 transparent transparent;
        left: -5px;
        top: calc(50% - 5px) !important;
        margin-left: 0;
        margin-right: 0;

    .popper.popper-tooltip[x-placement^="left"]
        margin-right: 5px;

    .popper.popper-tooltip[x-placement^="left"] .popper__arrow
        border-width: 5px 0 5px 5px;
        border-color: transparent transparent transparent #303133;
        right: -5px;
        top: calc(50% - 5px) !important;
        margin-left: 0;
        margin-right: 0;
</style>

